export function calculateHoursBetweenDates(
  startDate: Date,
  endDate: Date
): number {
  const millisecondsPerHour = 1000 * 60 * 60;
  const timeDifferenceInMilliseconds = endDate.getTime() - startDate.getTime();
  const hoursDifference = timeDifferenceInMilliseconds / millisecondsPerHour;
  return Math.round(hoursDifference);
}
